/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component } from 'llama'
import FaceConfig from '../../common/FaceConfig'
import ApiClient from '../api-client'

export default class FacePartSelector extends Component {
  constructor (opt) {
    super(opt)
    this.num = opt.num
    this.draw = opt.draw
    this.width = opt.width
    this.height = opt.height
    this.shape = opt.shape
  }

  init (params, path) {
    const config = FaceConfig.get()
    const allCnv = []
    const partChoiceContour = this.prepareBox()
    for (let i = 0; i < this.num; i++) {
      const cnv = this.fragmentFromHtml(`<canvas ${config[this.shape] === +i ? 'class="selected"' : ''}width="${this.width}" height="${this.height}"></canvas>`).firstChild
      allCnv.push(cnv)
      this.draw(cnv.getContext('2d'), i)
      partChoiceContour.appendChild(cnv)
      cnv.addEventListener('click', (e) => {
        e.preventDefault()
        this.emit(FaceConfig.UPDATE, { [this.shape]: i }, (faceConfig) => this.emit(ApiClient.UPDATE_DATA, { faceConfig }))
      })
    }
    this.on(FaceConfig.UPDATE, (changes) => {
      allCnv.forEach((c, i) => {
        if (FaceConfig.get(this.shape) === +i) {
          c.classList.add('selected')
        } else {
          c.classList.remove('selected')
        }
      })
    })
  }
}
